import confetti from "canvas-confetti";

export function celebrate() {
  // Burst from two corners — clean, doesn't block UI
  const colors = ["#00C97A", "#FFFFFF", "#F59E0B", "#8B5CF6"];
  confetti({
    particleCount: 60,
    spread: 60,
    startVelocity: 35,
    origin: { x: 0.2, y: 0.7 },
    colors,
    scalar: 0.9,
  });
  confetti({
    particleCount: 60,
    spread: 60,
    startVelocity: 35,
    origin: { x: 0.8, y: 0.7 },
    colors,
    scalar: 0.9,
  });
}

export async function requestPushPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    return await Notification.requestPermission();
  } catch (_) {
    return "denied";
  }
}

export function showPush(title, body, link) {
  if (!("Notification" in window) || Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, {
      body,
      icon: "/favicon.ico",
      badge: "/favicon.ico",
      tag: link || title,
      silent: false,
    });
    if (link) {
      n.onclick = () => {
        window.focus();
        window.location.href = link;
        n.close();
      };
    }
  } catch (_) {}
}
